export default {
  offlineMode: 'Offline-Modus',
};
